/*
 * @Description: 线上数据管理
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const onlineDtaManagementRouter: Array<RouteRecordRaw> = [
    {
        path: '/onlineDtaManagement',
        component: Layout,
        redirect: '/onlineDtaManagement/onlineDataUser',
        children: [
            {
                path: 'onlineDataUser',
                component: () => import(/* webpackChunkName: "OnlineDataUser" */ '@/views/onlineDtaManagement/onlineDataUser/index.vue'),
                name: 'OnlineDataUser',
                meta: { title: '线上用户' },
            },
            {
                path: 'onlineDataClass',
                component: () => import(/* webpackChunkName: "OnlineDataClass" */ '@/views/onlineDtaManagement/onlineDataClass/index.vue'),
                name: 'OnlineDataClass',
                meta: { title: '线上课堂' },
            },
            {
                path: 'onlineDataCourseDetail',
                component: () => import(/* webpackChunkName: "OnlineDataCourseDetail" */ '@/views/academicAffairs/courseManage/courseStatistics.vue'),
                name: 'OnlineDataCourseDetail',
                meta: { title: '课堂统计' },
            }
        ]
    }
]

export default onlineDtaManagementRouter
